export default __webpack_public_path__ + "images/salesforce-logo.a163f4335a1836f64f6a50d26978adb7.png";